import './output.css';
import { useState } from 'react';
import { useScrollPosition } from './hooks/useScrollPosition.js';

const formUrl = 'https://forms.gle/piavfMRUJUCjkwdF6'

function NavbarElement({ special, text, url, popup }) {
  return (
    <a 
      class="mx-6 first:ml-0"
      rel="noreferrer"
      target={ url.startsWith('https') ? '_blank' : '' }
      href={ url === "" ? null : url } 
      onClick={ () => {
        if (popup) { popup(true) }
        }
      }
    >
      <button class="ui-link group f-ui-1 inline-block relative ui-link--inherit relative" id="navlistlabel0" aria-expanded="false">
        <span class="flex items-center">
          <span class="flex items-center group">
            <span class={
              classNames(
                "f-ui-1 leading-none underline-thickness-1 underline-offset-4 group-hover:underline group-hover:underline-inherit underline-transparent",
                special ? 'text-amber-300 font-extrabold text-[1.3rem]' : 'text-xl',
              )}
            >
              { text }
            </span>
          </span>
        </span>
      </button>
    </a>
  )
}

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function MobileNavbar({ popup }) {
  const scrollPosition = useScrollPosition();
  const [isMenuOpen, setMenuOpen] = useState(false);
  function NavbarElement({ special, text, url, popup }) {
    return (
      <a 
        class="w-full block px-12 py-3 border-gray-800"
        rel="noreferrer"
        target={ url.startsWith('https') ? '_blank' : '' }
        href={ url === "" ? null : url } 
        onClick={ () => {
          setMenuOpen(false)
          if (popup) { popup(true) }
          }
        }
      >
        <button class="ui-link group f-ui-1 inline-block relative ui-link--inherit relative" id="navlistlabel0" aria-expanded="false">
          <span class="flex items-center">
            <span class="flex items-center group">
              <span class={
                classNames(
                  "f-ui-1 leading-none underline-thickness-1 underline-offset-4 group-hover:underline group-hover:underline-inherit underline-transparent",
                  special ? 'text-amber-300 font-extrabold text-[1.3rem]' : 'text-xl',
                )}
              >
                { text }
              </span>
            </span>
          </span>
        </button>
      </a>
    )
  }

  return (
    <div 
      class="md:hidden top-0 left-0 w-full z-[90] text-sm text-[color:white] fixed transition-all duration-300"
    >
      <header 
        class={classNames(
          scrollPosition > 0 ? 'bg-black' : 'bg-[transparent]',
          'h-16 py-5 flex flex-row flex-nowrap relative'
        )}
      >
        <div class={classNames(
          scrollPosition > 0 ? 'text-white' : 'text-transparent',
          'px-10 font-serif text-2xl transition-all duration-300'
        )}>
          W. KUKLINOWSKI
        </div>

        <img 
          src="menu.svg" 
          class="h-full mr-3 absolute top-0 right-0 p-5" 
          style={{filter: 'invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)'}}
          onClick={() => {setMenuOpen(!isMenuOpen)}}
        />
      </header>
      <ul 
        class={
          classNames(
            "transition-all duration-100 items-center justify-items-center flex flex-col justify-center items-baseline border border-gray-800 py-4 bg-black transition-discrete",
            isMenuOpen ? "opacity-100" : "opacity-0 hidden",
          )}
      >
        <NavbarElement url="#offer" text="Oferta" />
        <NavbarElement url="#about" text="O mnie" />
        <NavbarElement url="#contact" text="Kontakt" />
        <NavbarElement url={formUrl} text="Ankieta" />
        <NavbarElement special={true} url="" text="Bezpłatna konsultacja" popup={popup} />
      </ul>
    </div>
  );
}

function Navbar({ popup }) {
  const scrollPosition = useScrollPosition();

  return (
    <header 
      class={classNames(
        scrollPosition > 0 ? 'bg-black' : 'bg-[transparent]',
        "hidden md:flex top-0 left-0 w-full z-[90] py-5 h-16 text-sm text-[color:white] sticky transition-all duration-300 flex-row relative justify-between flex-nowrap"
      )}
    >
      <div class={classNames(
        scrollPosition > 0 ? 'text-white' : 'text-transparent',
        'px-10 font-serif text-2xl transition-all duration-300 w-[14em] overflow-clip'
      )}>
        W. KUKLINOWSKI
      </div>
      <ul class="items-center justify-items-center flex flex-row flex-wrap justify-center items-baseline">
        <NavbarElement url="#offer" text="Oferta" />
        <NavbarElement url="#about" text="O mnie" />
        <NavbarElement url="#contact" text="Kontakt" />
        <NavbarElement url={formUrl} text="Ankieta" />
        <NavbarElement special={true} url="" text="Bezpłatna konsultacja" popup={popup} />
      </ul>
      <div class="object-contain flex flex-row justify-end h-8 mx-10 flex-nowrap h-full w-[14em] space-x-8">
        <a href="mailto:wladekprogym@gmail.com">
          <Mail class="hover:brightness-75 transition-100 transition-full"/>
        </a>
        <a rel="noreferrer" target="_blank" href="https://instagram.com/wkbbi">
          <Instagram class="h-6 hover:brightness-75 transition-100 transition-full"/>
        </a>
      </div>
    </header>
  )
}

function Contact() {
  function ContactSource({ text, Icon, href }) {
    return (
      <div class="h-10 p-[0.4em] my-3">
        <Icon class="h-full mr-5"/> 
        <a 
          target={ typeof href === 'string' && href.startsWith('https') ? '_blank' : '' }
          rel="noreferrer"
          class={classNames(
            "decoration-sky-400 text-lg cursor-pointer text-sky-400 hover:text-sky-300 active:text-sky-800",
            (typeof href === 'string') ? 'underline' : '',
          )}
          href={href}
          onClick={
            () => {
              if (href == null) {
                navigator.clipboard.writeText("tet")
              }
            }
          }
        >
          {text}
        </a>
      </div>
    );
  }
  return (
    <div class="scroll-mt-24 pb-[12rem] pt-10 md:px-24 px-8" id="contact"> 
      <div class="block text-center text-white font-serif text-5xl mb-12">
        KONTAKT
      </div>
      <div class="flex flex-col md:flex-row md:justify-around">
        <div class="mb-10">
          <div class="my-12 text-3xl font-serif hidden md:visible">
            SKONTAKTUJ SIĘ ZE MNĄ
          </div>
          <div class="flex flex-col">
            <ContactSource text="wkbbi" Icon={Instagram} rel="noreferrer" target="_blank" href="https://www.instagram.com/wkbbi/"/>
            <ContactSource text="wladekprogym@gmail.com" href="mailto:wladekprogym@gmail.com" Icon={Mail}/>
            <ContactSource text="+48 533 083 467" Icon={Phone}/>
          </div>
        </div>
        <div 
          class="md:w-1/3 flex flex-col relative bg-black opacity-85"
        >
          <span class="text-3xl text-center block w-full font-semibold font-serif mb-8">
            WYPEŁNIJ ANKIETĘ
          </span>
          <span class="mb-12 text-xl pt-4 block">
            Wiesz, czego szukasz? Wypełnij szczegółową ankietę i bierzmy się do roboty!
          </span>
          <a class='h-max-content mt-auto w-full text-center text-xl mx-auto border border-white block py-2 hover:bg-white hover:text-black rounded' target="_blank" rel="noreferrer" href={formUrl}>
            <Form class="h-6 mx-2"/> <span class="text-sky-400">Wypełnij ankietę</span>
          </a>
        </div>
      </div>
    </div>
  );
}

function About() {
  return (
    <div id="about" class="flex md:flex-row flex-col max-w-[80rem] md:h-screen md:max-h-[40rem] container mx-auto p-5 scroll-mt-24">
      <img src="o-mnie.jpg" class="md:h-full md:w-1/2 h-[24rem] w-full md:object-contain object-cover"/>
      <div class="md:w-1/2 w-full">
        <span class="block text-4xl text-center font-serif p-6">
          O MNIE
        </span>
        <div class="w-full p-10 text-xl mx-auto">
          Cześć! Nazywam się Władysław Kuklinowski.
          <br/>
          <br/>
          Jestem trenerem od 2018 roku oraz czynnym zawodnikiem sportów sylwetkowych. Moja specjalizacja to szeroko rozumiana 
          <span class="font-semibold text-sky-400"> zmiana jakości życia</span>. Pomagam schudnąć i zbudować atletyczną, zdrową sylwetkę za pomocą optymalizacji treningowej, stosując przy tym wiedzę z zakresu  dietetyki sportowej oraz ukończonych licznych szkoleń, kursów popartych badaniami oraz własną praktyką.
        </div>
      </div>
    </div>
  );
}

function Instagram(props) {
  return (
    <img class={classNames(props.class, 'inline-block')} style={{filter: 'invert(100%) sepia(100%) saturate(1%) hue-rotate(138deg) brightness(107%) contrast(102%)'}} src="instagram-svgrepo-com.svg"/>
  );
}

function Mail(props) {
  return (
    <img class={classNames(props.class, 'inline-block')} style={{filter: 'invert(100%)'}}src="mail.svg"/>
  );
}

function ArrowLeft(props) {
  return (
    <img class={classNames(props.class, 'inline-block')} style={{filter: 'invert(100%)'}} src="arrow-left.svg"/>
  );
}

function ArrowRight(props) {
  return (
    <img class={classNames(props.class, 'inline-block')} style={{filter: 'invert(100%)'}} src="arrow-right.svg"/>
  );
}

function Phone(props) {
  return (
    <img class={classNames(props.class, 'inline-block')} style={{filter: 'invert(100%)'}}src="phone.svg"/>
  );
}

function Form(props) {
  return (
    <img class={classNames(props.class, 'inline-block')} style={{filter: 'invert(100%) sepia(100%) saturate(1%) hue-rotate(138deg) brightness(107%) contrast(102%)'}} src="form-svgrepo-com.svg"/>
  );
}

function Spacer(props) {
  return (
    <div id={props.id} class={classNames("my-12 block w-full h-10 flex", props.class)}>
      <div class="border-t block w-full my-auto border-gray-800 max-w-7xl mx-auto"/>
    </div>
  );
}

function Offer() {
  function Subcard({title, cost, text, currency, points = [], img = "DSC_2177.jpg"}) {
    return (
      <div id="offer" class="flex-1 flex flex-col mx-4">
        <div class="aspect-w-8 aspect-h-9 my-8">
          <img class="object-cover max-w-100%" src={img}/>
        </div>

        <div class='ml-1'>
          <div class="font-semibold text-3xl decoration-1 underline-offset-4 font-serif decoration-white/50 mb-3">
            {title}
          </div>
          <div class="text-xl mb-5 block font-semibold font-serif">
            {cost}<span class="text-md font-light font-serif">{currency}</span>
          </div>
          {points.map(point => {
            return (
              <li class="text-white text-xl font-semibold my-2 list-outside">
                {point}
              </li>
            )
          })}

          <div class="block group w-full relative">
            <div class="invisible text-white duration-300 block transition-all transition-100 border-2 rounded p-4 border-slate-600 absolute opacity-0 group-hover:opacity-100 group-hover:visible text-lg w-full bg-black z-[20]">
              {text}
            </div>
            <div class="mt-4 underline text-sky-400 font-bold text-xl">
              Dowiedz się więcej
            </div>
          </div>
        </div>


      </div>
);
  }
  return (
    <div class="scroll-mt-24" id="offer">
      <div class="block text-center text-white font-serif text-4xl my-10">
        OFERTA
      </div>
      <div class="flex md:flex-row flex-col justify-stretch md:mx-24 mx-14 mb-20">
        <Subcard 
          title="PLAN TRENINGOWY"
          cost="300"
          currency="zł"
          text={
            <div>
              Po
              &nbsp;
              <a href="#contact" class="font-semibold underline text-sky-400 hover:text-sky-200">
                wypełnieniu formularza
              </a>
              &nbsp;
              otrzymasz plan treningowy z autorskimi filmikami ilustrującymi technikę, dostosowany do Ciebie i Twoich możliwości oraz dietetyczne wytyczne działania. 
              Po otrzymaniu planu treningowego umawiamy się na konsultację omawiającą strukturę całego planu.
            </div>
          }
          points={["Autorski plan treningowy", "Plan dostosowany do stylu życia", "Formularz i rozmowa konsultacyjna", "Dieta"]}
          img="plan-treningowy.jpg"
        />
        <Spacer class="md:hidden" />
        <Subcard 
          title="WSPÓŁPRACA ONLINE"
          cost="450"
          currency="zł/msc"
          img="rozmowa-online.jpg"
          text={
            <div>
              Współpraca rozpoczyna się od&nbsp;
              <a href="#contact" class="font-semibold underline text-sky-400 hover:text-sky-200">
                wypełnienia formularza
              </a>
              . Po wypełnieniu otrzymasz plik w którym znajdzie się Twój plan treningowy oraz dietetyczne wytyczne działania. 
              W planie znajdziesz autorskie filmy z wykonywanymi ćwiczeniami, uwzględnione priorytety partii, wyliczoną optymalną objętość i wiele innych wskazówek! 
              Co tydzień w wybranym dniu kontaktujemy się ze sobą i omawiamy kwestie dotyczące treningu oraz diety. Przygotuj się na nagrywanie swoich treningów :) 
            </div>
          }
          points={["Konsultacje online", "Autorski plan treningowy"]}
        />
        <Spacer class="md:hidden"/>
        <Subcard 
          title="TRENING PERSONALNY"
          cost="160"
          currency="zł"
          text="Treningi stacjonarne odbywają się w Białej Podlaskiej w klubie ProGym."
          points={["Praca nad techniką", "Autorski plan treningowy", "Dietetyka sportowa"]}
          img="trening-personalny.jpg"
        />
        {/* <Subcard /> */}
        {/* <Subcard /> */}
      </div>
    </div>
  );
}

function Star({classNames}) {
  return (
    <img class={classNames} src="/star.svg"></img>
  )
}

function Opinions() {
  const opinions = [
    [
      "Hej hej, jednej maszyny nie mam na swojej siłowni, ale to szczegół. Napracowałeś się z tymi filmikami co? Ułatwiają trening mocno😊.",
      "Łukasz"
    ],
    [
      "Plan idealnie pasuje do moich celów, jest dobrze zbalanoswany i intesnsyny, a przy tym świetnie motywuje mnie do regularnych treningów i daje widoczne efekty 💪.",
      "Kacper"
    ],
    [
      "Jestem bardzo zadowolona z planu, idealnie dopasowałeś ćwiczenia pode mnie jak i pod możliwości miejsc, w których trenuje. Dodatkowo wszystkie ciwczenia są cudownie wytłumaczone dzięki filmikom. Czuję się na maxa zapokieowana, nie mogę się już doczekać efektów!🤗",
      "Jula"
    ],
    [
      "Cześć! Chciałem Ci podziękować za ten plan treningowy. Jest świetnie rozpisany i dobrze dopasowany do moich potrzeb. Ćwiczenia są różnorodne,a progresja pomaga mi robić regularne postępy. 🫠Super, że zawsze mogę liczyć na Twoją pomoc, gdy mam jakieś pytania. Dzięki za rozpisanie kaloryki i suplementów, to naprawdę pomaga w trzymaniu diety. Jestem bardzo zadowolony z efektów, dzięki!🤩 ",
      "Bartek"
    ],
    [
      "Publicznie się nie chcę chwalić, ale dla trenera podeślę, że redukcja zakończona sukcesem. Bardzo dziękuję za plan, rozpiskę makro i wsparcie, sama bym tego chyba nie doprowadziła do końca!🤗",
      "Zuza"
    ],
    [
      "Mega profesjonalnie i konkretnie, a przy tym Władek to bardzo normalny i życzliwy człowiek!😊Plan treningowy dostosoany do moich potrzeb i czasu. Dołączone filmiki pozwalają na poprawne wykonyawnie ćwiczeń. Super kontakt. Polecam",
      "Łukasz"
    ]
  ];

  const [index, setIndex] = useState(1)

  function Opinion({text, author, i, key}) {
    return (
      <div class={classNames(
          "inline-block my-4 mx-20 duration-300 transition-opacity",
        )}
        style={{
          filter: index === i ? '' : 'blur(2px)',
          opacity: index === i ? '100%' : '80%'
        }}
        key={i}
      >
        {/* style={{blur: index == i ? '8px' : '0'}} */}
          {/* style={{opacity: index == i ? '100%' : '50%'}} */ }
        <div class="rounded-3xl bg-slate-800 p-5 w-96">
          <div class="flex mb-3">
            <Star classNames="w-4 inline-block mr-1"/>
            <Star classNames="w-4 inline-block mr-1"/>
            <Star classNames="w-4 inline-block mr-1"/>
            <Star classNames="w-4 inline-block mr-1"/>
            <Star classNames="w-4 inline-block mr-1"/>
          </div>
          {text}
        </div>
        <div class="inline-block font-bold text-lg ml-10 mt-4">
          {author}
        </div>
      </div>
    )
  }

  return (
    <div id="opinions" class="flex flex-col w-full relative md:h-[42rem] scroll-mt-24 overflow-clip">
      <div class="block text-center text-white font-serif text-4xl my-10">
        OPINIE
      </div>
      <div>
        <div class="absolute left-1/2 justify-self-center w-[100rem] mx-auto flex flex-row transition-all duration-500"
          style={{
            transform: `translateX(${-51 - (index-1) * 34}%)`
          }}
        >
          {opinions.map(([text, author], i) => {
            return (
              <Opinion key={i.toString()} i={i} text={text} author={author}/>
            );
          })}
        </div>
        <div class="flex flex-row justify-center mt-[24rem]">
          <div class="bg-slate-800 rounded-full mx-8"
            onClick={() => { console.log(index); setIndex((index - 1 + opinions.length) % opinions.length) }}
          >
            <ArrowLeft class="w-8 m-2"/>
          </div>
          <div class="bg-slate-800 rounded-full mx-8"
            onClick={() => { setIndex((index + 1) % opinions.length) }}
          >
            <ArrowRight class="w-8 m-2"/>
          </div>
        </div>
      </div>
    </div>
  );
}

function Section1() {
  return (
    <div id="info" class="flex md:flex-row flex-col md:h-[20rem] max-w-[120rem] mx-auto scroll-mt-24">
      <div class="md:w-1/2 w-full">
        <div class="flex font-serif text-4xl mx-auto w-100% justify-center my-4">
          <span> DIETA </span>
        </div>
        <div class="md:w-[34rem] mx-auto text-lg my-4 p-6">
          We współpracy ze mną nie otrzymasz gotowych posiłków, za to nauczę Cię jak korzystać ze swoich ulubionych lub znaleźć w nich rozsądne zamienniki. Wytłumaczę Ci, że zdrowe nawyki są dużo bardziej efektywne niż dieta, w której ciężko wytrzymać. Otrzymasz makrocykl oparty na dietetyce sportowej więc wiele będzie zależeć od Ciebie! 
        </div>
      </div>
      <img src="chicken.jpg" class="md:w-1/2 w-full object-cover"/>
    </div>
  )
}

function Section3() {
  return (
    <div class="flex md:flex-row flex-col md:h-[20rem] max-w-[120rem] mx-auto">
      <div class="md:w-1/2 w-full p-6">
        <div class="flex font-serif text-4xl mx-auto w-100% justify-center my-10">
          <span> PRZYGOTOWANIE DO ZAWODÓW </span>
        </div>
        <div class="md:w-[24rem] mx-auto text-lg">
          Zapraszam do współpracy również ambitnych sportowców, którzy chcą pokazać się na scenie jako zawodnik. Wszelkie szczegóły i informacje omówimy na konsultacji i wstępnej analizie oraz pozowaniu.
        </div>
      </div>
      <img src="zawody.jpg" class="md:w-1/2 md:order-first object-cover"/>
    </div>
  )
}

function Consultation({ open }) {
  var [isOpen, setOpen] = open
  
  return (
    <div class={classNames(isOpen ? "" : "hidden", 'p-10')}>
      <div 
        class="fixed top-0 left-0 w-screen h-screen z-[90] bg-[rgba(0,0,0,0.5)]"
        onClick={() => {setOpen(false)}}
      >
      </div>
      {/* <div  */}
      {/*   class="fixed w-screen h-screen z-[100] transition-300 transition-all grid justify-center content-center" */}
      {/* > */}
        <div class="fixed z-[100] inset-0 md:mx-auto my-auto md:w-[40rem] h-[30rem] m-5 flex flex-col bg-black border-2 rounded-xl border-slate-800 radius-1 md:text-start text-center">
          <img src="x.svg" class="absolute right-0 top-0 w-14 h-14 p-2 hover:opacity-70"
            onClick ={ () => setOpen(false) }
          />
          <div class="flex font-serif text-3xl mx-auto w-100% justify-center mt-14 pb-10 border-b border-slate-900">
            <span> BEZPŁATNA KONSULTACJA </span>
          </div>
          <div class="md:w-[24rem] mt-14 mx-auto text-lg">
            <a class="underline decoration-sky-400 cursor-pointer text-sky-400 hover:text-sky-300 active:text-sky-800" href="#contact">
              Umów się ze mną
            </a>  na <span class="font-semibold">darmową</span> konsultację, jeżeli masz pytania dotyczące współpracy!

          </div>
          <a class='h-max-content mt-auto w-[20rem] text-center text-xl mx-auto border border-white block py-2 hover:bg-gray-700 hover:text-black rounded mb-14 self-end' href={formUrl}>
            <Form class="h-6 mx-2"/> <span class="text-sky-400">Wypełnij ankietę</span>
          </a>
        </div>
      {/* </div> */}
    </div>
  )
}

function App() {
  const [consultationOpen, setConsultationOpen] = useState(false)

  return (
    <div class="relative bg-black font-sans text-white">
      <MobileNavbar popup={setConsultationOpen}/>
      <Navbar popup={setConsultationOpen}/>
      {/* <ContactBox />  required overflow-clip or something on below div*/} 
      <div class="relative h-screen w-full md:-mt-16 overflow-clip">
        <img class="object-cover h-full w-full block md:object-center object-[25%_0%] mr-2" src="glowna.jpg"/>
        <div class="text-white absolute top-0 bottom-0 right-0 left-0 z-[20] w-full h-screen bg-[rgba(0,0,0,0.3)]">
          <div class="font-serif container mx-auto absolute text-center bottom-16 left-0 right-0">
            <div class="md:text-8xl text-4xl">WŁADYSŁAW KUKLINOWSKI</div>
            <div class="md:text-4xl text-2xl font-light">TRENER PERSONALNY</div>
          </div>
        </div>
      </div>

      <Spacer />
      <Offer />

      <Spacer/>
      <Section1 />
      <Section3 />

      <Spacer />
      <About />
      <Spacer />
      <Opinions />

      <Spacer />
      <Contact />
      <div class="py-6 border-t block w-full my-auto border-gray-800 max-w-7xl mx-auto"/>

      <Consultation open={[ consultationOpen, setConsultationOpen ]}/>
    </div>
  );
}

export default App;
